import {
  TURNOSPACIENTE_ERROR,
  TURNOSPACIENTE_LOADING,
  TURNOSPACIENTE_SUCCESS,
  LOGOUT_USER,
  TURNOSPACIENTE_RESET,
  TURNOSPACIENTE_LISTAMULTIMEDIA,
  TURNOSPACIENTE_PLANKINESIO,
  TURNOSPACIENTE_CANCELARPLANKINESIO,
  TURNOSPACIENTE_RESET_CANCELARPLANKINESIO,
  TURNOSPACIENTE_LIMPIAR_PLANKINESIO,
  TURNOSPACIENTE_ESTADOVIDEOLLAMADA,
  TURNOSPACIENTE_ULTIMOTURNO,
  TURNOSPACIENTE_TIPOTURNO,
  TURNOSPACIENTE_TIPOTURNO_RESET,
  TURNOSPACIENTE_MATRICULAMEDICO,
  TURNOSPACIENTE_GUARDAR_MATRICULAMEDICO,
  TURNOSPACIENTE_LIMPIAR_MATRICULAMEDICO,
  TURNOSPACIENTE_DATOSMEDICO,
  TURNOSPACIENTE_PUT_DATOSMEDICO,
  TURNOSPACIENTE_LIMPIAR_DATOSMEDICO,
  TURNOSPACIENTE_CAMBIARESTADO,
  TURNOSPACIENTE_CAMBIARESTADO_RESET,
  TURNOSPACIENTE_TURNOSOLICITUD,
  TURNOSPACIENTE_RESET_TURNOSOLICITUD,
  TURNOSPACIENTE_SUBIDAORDEN_LOADING,
  TURNOSPACIENTE_SUBIDAORDEN_LOADING_RESET,
  RESET_PORTAL_CONTEXT,
} from "../ActionTypes";

import turnosPacienteInitialState from "../initialStates/turnosPacienteInitialState";

const turnosPaciente = (state, { payload, type }) => {
  switch (type) {
    case TURNOSPACIENTE_LOADING:
      return {
        ...state,
        turnosPaciente: {
          ...state.turnosPaciente,
          error: false,
          loading: true,
        },
      };
    case TURNOSPACIENTE_SUCCESS:
      return {
        ...state,
        turnosPaciente: {
          ...state.turnosPaciente,
          loading: false,
          error: false,
          data: payload,
          flgOrden: null,
        },
      };
    case TURNOSPACIENTE_ERROR:
      return {
        ...state,
        turnosPaciente: {
          ...state.turnosPaciente,
          error: payload,
          loading: false,
        },
      };
    case TURNOSPACIENTE_LISTAMULTIMEDIA:
      return {
        ...state,
        turnosPaciente: {
          ...state.turnosPaciente,
          loading: false,
          error: false,
          listaMultimedia: payload,
        },
      };

    case TURNOSPACIENTE_PLANKINESIO:
      return {
        ...state,
        turnosPaciente: {
          ...state.turnosPaciente,
          loading: false,
          error: false,
          planKinesio: payload,
        },
      };
    case TURNOSPACIENTE_LIMPIAR_PLANKINESIO:
      return {
        ...state,
        turnosPaciente: {
          ...state.turnosPaciente,
          loading: false,
          error: false,
          planKinesio: [],
        },
      };
    case TURNOSPACIENTE_ESTADOVIDEOLLAMADA:
      return {
        ...state,
        turnosPaciente: {
          ...state.turnosPaciente,
          loading: false,
          error: false,
          cambioEstado: payload,
        },
      };
    case TURNOSPACIENTE_ULTIMOTURNO:
      return {
        ...state,
        turnosPaciente: {
          ...state.turnosPaciente,
          loading: false,
          error: false,
          ultimoTurno: payload,
        },
      };
    case TURNOSPACIENTE_TIPOTURNO:
      return {
        ...state,
        turnosPaciente: {
          ...state.turnosPaciente,
          tipoTurno: payload,
        },
      };
    case TURNOSPACIENTE_TIPOTURNO_RESET:
      return {
        ...state,
        turnosPaciente: {
          ...state.turnosPaciente,
          tipoTurno: null,
        },
      };
    case TURNOSPACIENTE_TURNOSOLICITUD:
      return {
        ...state,
        turnosPaciente: {
          ...state.turnosPaciente,
          loading: false,
          error: false,
          turnoSolicitud: payload,
        },
      };
    case TURNOSPACIENTE_RESET_TURNOSOLICITUD:
      return {
        ...state,
        turnosPaciente: {
          ...state.turnosPaciente,
          loading: false,
          error: false,
          turnoSolicitud: null,
        },
      };
    case TURNOSPACIENTE_MATRICULAMEDICO:
      return {
        ...state,
        turnosPaciente: {
          ...state.turnosPaciente,
          loading: false,
          error: false,
          data: payload,
        },
      };
    case TURNOSPACIENTE_DATOSMEDICO:
      return {
        ...state,
        turnosPaciente: {
          ...state.turnosPaciente,
          loading: false,
          error: false,
          datosMedico: payload,
        },
      };
    case TURNOSPACIENTE_PUT_DATOSMEDICO:
      return {
        ...state,
        turnosPaciente: {
          ...state.turnosPaciente,
          loading: false,
          error: false,
          datosMedico: payload,
        },
      };
    case TURNOSPACIENTE_GUARDAR_MATRICULAMEDICO:
      return {
        ...state,
        turnosPaciente: {
          ...state.turnosPaciente,
          loading: false,
          error: false,
          matriculaMedico: payload,
        },
      };
    case TURNOSPACIENTE_CAMBIARESTADO:
      return {
        ...state,
        turnosPaciente: {
          ...state.turnosPaciente,
          loading: false,
          error: false,
          cambioEstado: true,
        },
      };
    case TURNOSPACIENTE_CAMBIARESTADO_RESET:
      return {
        ...state,
        turnosPaciente: {
          ...state.turnosPaciente,
          loading: false,
          error: false,
          cambioEstado: null,
        },
      };
    case TURNOSPACIENTE_LIMPIAR_MATRICULAMEDICO:
      return {
        ...state,
        turnosPaciente: {
          ...state.turnosPaciente,
          loading: false,
          error: false,
          matriculaMedico: null,
        },
      };
    case TURNOSPACIENTE_LIMPIAR_DATOSMEDICO:
      return {
        ...state,
        turnosPaciente: {
          ...state.turnosPaciente,
          loading: false,
          error: false,
          datosMedico: null,
        },
      };
    case TURNOSPACIENTE_CANCELARPLANKINESIO:
      return {
        ...state,
        turnosPaciente: {
          ...state.turnosPaciente,
          loading: false,
          error: false,
          cancelarSesion: true,
        },
      };
    case TURNOSPACIENTE_RESET_CANCELARPLANKINESIO:
      return {
        ...state,
        turnosPaciente: {
          ...state.turnosPaciente,
          loading: false,
          error: false,
          cancelarSesion: false,
        },
      };
    case TURNOSPACIENTE_SUBIDAORDEN_LOADING:
      return {
        ...state,
        turnosPaciente: {
          ...state.turnosPaciente,
          flgOrden: true,
        },
      };
    case TURNOSPACIENTE_SUBIDAORDEN_LOADING_RESET:
      return {
        ...state,
        turnosPaciente: {
          ...state.turnosPaciente,
          flgOrden: null,
        },
      };

    case TURNOSPACIENTE_RESET:
      return turnosPacienteInitialState;

    case LOGOUT_USER:
      return turnosPacienteInitialState;
      
    case RESET_PORTAL_CONTEXT:
      return turnosPacienteInitialState;

    default:
      return state;
  }
};

export default turnosPaciente;
